class CollectionPreview extends HTMLElement {
  #activeId = null;


  connectedCallback() {
    this.links = this.querySelectorAll('[data-link-id]');
    this.boundMouseOverHandler = this.handleMouseOver.bind(this);
    this.links.forEach((link) => {
      link.addEventListener('mouseover', this.boundMouseOverHandler);
    });
    this.mediaElements = this.querySelectorAll('[data-media-id]');
    this.activateFirst();
  }

  disconnectedCallback() {
    if (this.links && this.boundMouseOverHandler) {
      this.links.forEach((link) => {
        link.removeEventListener('mouseover', this.boundMouseOverHandler);
      });
    }
  }

  handleMouseOver(event) {
    const linkId = event.currentTarget.dataset.linkId;
    if (linkId) {
      this.#activeId = linkId;
      this.activateMedia();
      this.activateLink();

    }
  }

  activateLink() {
    this.links.forEach((link) => {
      if (link.dataset.linkId === this.#activeId) {
        link.classList.add('active');
      } else {
        link.classList.remove('active');
      }
    });
  }

  activateMedia() {
    this.mediaElements.forEach((media) => {
      if (media.dataset.mediaId === this.#activeId) {
        media.classList.add('active');
      } else {
        media.classList.remove('active');
      }
    });
  }

  activateFirst() {
    if (this.links.length > 0) {
      this.#activeId = this.links[0].dataset.linkId;
      this.activateLink();
      this.activateMedia();
    }
  }
}

if (!customElements.get('collection-preview')) {
  customElements.define('collection-preview', CollectionPreview);
}
